import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { deleteDraftAsk } from "../../../store/actions/ask/drafts";
import {
  displayErrorToast,
  displaySuccessToast
} from "../../../store/actions/overflowNotification";
import TSDialog from "../../general/dialog";
import { useNavigate } from "react-router-dom";

const RequestMenu = props => {
  const {
    sent,
    answerId,
    // templateId,
    completed    
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const main = useSelector(state => state.main);
  const myType = main.myType;

  const [confirmDeleteDraft, setConfirmDeleteDraft] = useState(null);
  const [confirmDeleteSurvey, setConfirmDeleteSurvey] = useState(null);

  function renderDeleteSurveyDialog() {
    return (
      <TSDialog
        title={<FormattedMessage id="ask.pages.list.confirmDeleteTitle" />}
        okText={<FormattedMessage id="actions.delete" />}
        type="danger"
        visible={confirmDeleteDraft || confirmDeleteSurvey}
        onAbort={e => {
          e.stopPropagation();
          setConfirmDeleteDraft(null);
          setConfirmDeleteSurvey(null);
        }}
        onSubmit={e => {
          e.stopPropagation();
          onConfirmDeleteSurvey(confirmDeleteDraft || confirmDeleteSurvey);
          setConfirmDeleteDraft(null);
          setConfirmDeleteSurvey(null);
        }}
      >
        <FormattedMessage id="ask.pages.list.confirmDeleteSurveySubtitle" />
      </TSDialog>
    );
  }

  function onConfirmDeleteSurvey(surveyId) {
    if (confirmDeleteDraft) {
      dispatch(deleteDraftAsk(surveyId))
        .then(res => {
          dispatch(displaySuccessToast(<FormattedMessage id="ask.pages.list.requestCompleted"/>, "OK"));
        })
        .catch(res => {
          dispatch(displayErrorToast(<FormattedMessage id="ask.pages.list.requestError"/>,
            <FormattedMessage id="ask.pages.list.error"/>));
        });
    }
  }

  return myType === "STUDIO" ? (
    <div>
      <div style={{ display: "flex", flexDirection: "column", width: 136 }}>
        {answerId && sent ? (
          <div
            id={"askList-actions-popover-open_" + answerId}
            className="askList-actions-popover-row"
            onClick={() => navigate("/ask-answer/" + answerId)}
          >
            {completed ? (
              <FormattedMessage id="ask.pages.list.readResponse" />
            ) : (
              <FormattedMessage id="ask.pages.list.open" />
            )}
          </div>
        ) : null}
        {sent && (
          <div
            id={"askList-actions-popover-duplicate_" + answerId}
            onClick={(e) => {
              e.stopPropagation();
              navigate("/ask-edit?answerId=" + answerId);
            }}
            className="askList-actions-popover-row"
          >
            <FormattedMessage id="actions.duplicate" />
          </div>
        )}
        {!sent && (
          <div
            id={"askList-actions-popover-edit_" + answerId}
            onClick={e => {
              e.stopPropagation();
              navigate("/ask-edit?draftId=" + answerId);
            }}
            className="askList-actions-popover-row"
          >
            <FormattedMessage id="actions.edit" />
          </div>
        )}
        {!sent ? (
          <div
            id={"askList-actions-popover-delete_" + answerId}
            className="askList-actions-popover-row"
            onClick={e => {
              e.stopPropagation();
              setConfirmDeleteDraft(answerId);
            }}
          >
            <FormattedMessage id="actions.delete" />
          </div>
        ) : null}
      </div>
      {renderDeleteSurveyDialog()}
    </div>
  ) : (
    <div>
      <div style={{ display: "flex", flexDirection: "column", width: 126 }}>
        {answerId ? (
          <div
            className="askList-actions-popover-row"
            onClick={() => navigate("/ask-answer/" + answerId)}
          >
            Apri
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default RequestMenu;
